<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>Remove platform frontends</ng-container>

    <ng-container dialog-process-in-progress>
        <form [formGroup]="form.formGroup" class="row">
            <div class="col-12 pb-2">
                <span class="value pl-3 platform-frontend-subtitle">Platform frontend name</span>
            </div>

            <div appCheckPermissionRule
                 [rule]="permissionRule" class="col-12" *ngFor="let platform of form.controls">
                <div [ngClass]="{'mb-3': platform.errors?.length > 0}" class="col-12">
                    <app-checkbox
                        [control]="platform"
                        [formControlName]="platform.name"
                    >
                        <ng-container text>{{ platform.placeholder }}</ng-container>
                    </app-checkbox>
                </div>

            </div>

        </form>
    </ng-container>

</app-dialog>
